
<div class="modal-dialog instructions-preview-dialog-container">
  <div class="modal-content" cdkTrapFocus>
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate>{{title}}</h4>
      <button
        class="close-btn"
        type="button"
        [attr.aria-label]="'common_close' | translate"
        (click)="close()">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      <div translate="{{message}}"></div>
    </div>
    <div class="goreact-modal-footer">
      <label class="remember-label">
        <input type="checkbox" [(ngModel)]="remember"/>
        {{rememberText | translate}}
      </label>
      @if (rejectBtnText) {
        <button
          type="button"
          class="goreact-btn {{rejectBtnClass}}"
          (click)="close()"
          translate="{{rejectBtnText}}">
        </button>
      }
      <button
        type="button"
        class="goreact-btn {{resolveBtnClass}}"
        (click)="close()"
        translate="{{resolveBtnText}}">
      </button>
    </div>
  </div>
</div>
